<template>
    <FormControl
        :hideLabel="true"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Availability_WeekhlyHours,
            )
        "
    >
        <div class="space-y-8">
            <SingleWeeklyHoursForm
                :index="0"
                :weeklyHours="getWeeklyHoursByDayOfWeek(DayOfWeekEnum.Sunday)"
            />
            <SingleWeeklyHoursForm
                :index="1"
                :weeklyHours="getWeeklyHoursByDayOfWeek(DayOfWeekEnum.Monday)"
            />
            <SingleWeeklyHoursForm
                :index="2"
                :weeklyHours="getWeeklyHoursByDayOfWeek(DayOfWeekEnum.Tuesday)"
            />
            <SingleWeeklyHoursForm
                :index="3"
                :weeklyHours="
                    getWeeklyHoursByDayOfWeek(DayOfWeekEnum.Wednesday)
                "
            />
            <SingleWeeklyHoursForm
                :index="4"
                :weeklyHours="getWeeklyHoursByDayOfWeek(DayOfWeekEnum.Thursday)"
            />
            <SingleWeeklyHoursForm
                :index="5"
                :weeklyHours="getWeeklyHoursByDayOfWeek(DayOfWeekEnum.Friday)"
            />
            <SingleWeeklyHoursForm
                :index="6"
                :weeklyHours="getWeeklyHoursByDayOfWeek(DayOfWeekEnum.Saturday)"
            />
        </div>
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import {
        DayOfWeekEnum,
        type WeeklyHoursType,
    } from '@/Shared/AutoGenerated/Main'
    import Availability from '@/App/Availability/Entity/Availability'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import SingleWeeklyHoursForm from '@/App/Availability/Component/SingleWeeklyHoursForm.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        availability: {
            type: Object as PropType<Availability | null>,
            default: null,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const getWeeklyHoursByDayOfWeek = (
        dayOfWeek: DayOfWeekEnum,
    ): WeeklyHoursType => {
        const weeklyHours = props.availability?.weeklyHours.find(
            (weeklyHours: WeeklyHoursType) => {
                return weeklyHours.dayOfWeek === dayOfWeek
            },
        )

        if (!weeklyHours) {
            return Availability.newWeeklyHours(dayOfWeek)
        }

        return weeklyHours
    }
</script>
